module.exports = __webpack_public_path__ + "media/PW_KIDS_200_Website_Loop.466e8200.mp4";